let restrictedTerms: string[] = [];

const loadRestrictedTerms = async () => {
  try {
    const response = await fetch("/site_config/restricted_terms");
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    restrictedTerms = await response.json();
  } catch (error) {
    console.error("Error fetching restricted terms:", error);
    restrictedTerms = [];
  }
};

// Load the restricted terms once when the script starts
loadRestrictedTerms();

export const validateName = (name: string) => {
  if (restrictedTerms.length === 0) {
    console.warn("Restricted terms not loaded yet.");
    return true; // Consider valid until terms are loaded
  }

  const regex = new RegExp(`\\b(${restrictedTerms.join("|")})\\b`, "i");
  return !regex.test(name);
};

export const restrictedTermsError =
  "Please try another name as this currently contains restricted terms.";
